import { render } from "./DownloadInvoice.vue?vue&type=template&id=b5eb7a0a"
import script from "./DownloadInvoice.vue?vue&type=script&lang=js"
export * from "./DownloadInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__